import React from 'react'
import '../App.css'
import Bodyhomeadmintickets from './bodyhomeadmintickets'
export class Bodyapphomebodyadmintickets extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className='sshbodyapp'>
                <div className='sshbodyappContainer'>
                    <Bodyhomeadmintickets />
                </div>
            </div>
        );
    }
}